// Update instruction
export const UPDATE_INSTRUCTION = "UPDATE_INSTRUCTION"
export const UPDATE_INSTRUCTION_SUCCESS = "UPDATE_INSTRUCTION_SUCCESS"
export const UPDATE_INSTRUCTION_FAIL = "UPDATE_INSTRUCTION_FAIL"
export const UPDATE_INSTRUCTION_CLEAR = "UPDATE_INSTRUCTION_CLEAR"